export const specials = [
  {
    id: "city-darkness",
    title: "城市的暗面",
    subtitle: "韩国伦理悬疑的十年切片",
    cover: "https://readdy.ai/api/search-image?query=Rainy%20Seoul%20cityscape%20at%20night%20seen%20from%20a%20high%20window%2C%20glowing%20apartment%20windows%20and%20wet%20streets%2C%20deep%20navy%20and%20amber%20tones%2C%20moody%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=1200&height=760&seq=special-cover-01&orientation=landscape",
    intro:
      "从雨夜的首尔到空荡的法庭走廊，这十部作品共同描绘出韩国伦理悬疑的一条暗线：罪案只是入口，真正被审讯的是人与人之间的信任。",
    reasons: [
      "十年间，韩国伦理悬疑逐渐把叙事重心从「谁是凶手」移到「为什么所有人都不说」。这份片单按时间顺序排列，能清楚看到这种转向。",
      "入选作品全部以城市空间为核心：公寓、地铁、酒店、法院走廊。城市不只是背景，它决定了人物能走多远、藏多深。",
      "如果你刚开始接触这个类型，建议从《雨停之前》入手，再回头看《双重曝光》与《迷雾中的她》，会更容易理解视线与证据的关系。",
    ],
    filmIds: ["before-the-rain-stops", "double-exposure", "her-in-the-fog", "neighbor-in-daylight", "silent-testimony", "footsteps-outside", "her-second-name", "paper-moon"],
    curator: "编辑部 · 首尔观察组",
    publishedAt: "2025-09-02",
    tags: ["韩国", "悬疑伦理", "城市空间"],
  },
  {
    id: "quiet-tides",
    title: "静默与潮汐",
    subtitle: "日本影像中的家庭伦理",
    cover: "https://readdy.ai/api/search-image?query=Quiet%20Japanese%20seaside%20house%20at%20dusk%20with%20open%20shoji%20screens%20facing%20the%20ocean%2C%20wooden%20floors%20and%20soft%20indoor%20lamp%20light%2C%20muted%20indigo%20and%20sand%20palette%2C%20calm%20cinematic%20composition%2C%20no%20text&width=1200&height=760&seq=special-cover-02&orientation=landscape",
    intro:
      "日本家庭伦理片很少高声争吵。秘密藏在便当盒、木工房和退潮后的礁石里，人物用沉默维系关系，也用沉默把它耗尽。",
    reasons: [
      "这份片单聚焦「不说话的瞬间」：父亲失去语言能力、姐妹在堤坝上并肩坐着、夫妻只讨论窗帘要不要留下。沉默在这里不是空白，而是最密的信息。",
      "七部作品的季节感非常明确，春、夏、秋、冬各有所指。按季节顺序观看，会得到一条完整的情绪曲线。",
      "推荐搭配阅读《雪落无声》与《潮汐之间》两篇解析，它们几乎是同一主题的两种答案：一个选择留下，一个选择离开。",
    ],
    filmIds: ["snow-falls-quietly", "between-tides", "haru-no-kizu", "sea-in-the-room", "old-inn-by-the-sea", "echoes-of-summer", "vernal-equinox", "silent-confession"],
    curator: "编辑部 · 东京影像档案",
    publishedAt: "2025-07-18",
    tags: ["日本", "家庭伦理", "季节"],
  },
  {
    id: "short-edge",
    title: "短片的锋利边缘",
    subtitle: "三十分钟内完成一次伦理提问",
    cover: "https://readdy.ai/api/search-image?query=Minimal%20empty%20rehearsal%20room%20with%20three%20wooden%20chairs%20and%20hard%20window%20light%2C%20long%20shadows%20on%20a%20bare%20floor%2C%20muted%20grey%20and%20amber%20tones%2C%20artistic%20editorial%20photography%2C%20no%20text&width=1200&height=760&seq=special-cover-03&orientation=landscape",
    intro:
      "短片没有时间铺陈，只能把问题直接摆到桌面上。四部三十分钟以内的作品，每一部都只问一个问题，却都很难回答。",
    reasons: [
      "短片的伦理张力往往比长片更集中：一个房间、两个人、一段重复的对话，就足够让观众坐立不安。",
      "这四部作品在形式上都很大胆：有的用投影、有的用重复结构、有的用交叉剪辑。它们证明了预算不是叙事的限制。",
      "适合在通勤或睡前观看，每部结束后留十分钟给自己，想想你会怎么选。",
    ],
    filmIds: ["the-third-chair", "sea-in-the-room", "borrowed-diary", "last-subway"],
    curator: "编辑部 · 短片企划",
    publishedAt: "2025-05-11",
    tags: ["短片", "形式实验", "单场景"],
  },
  {
    id: "forbidden-lines",
    title: "禁忌的边界",
    subtitle: "改编、凝视与被省略的人",
    cover: "https://readdy.ai/api/search-image?query=Backstage%20theatre%20with%20a%20huge%20paper%20moon%20prop%20and%20a%20single%20warm%20spotlight%20on%20an%20empty%20stage%2C%20deep%20charcoal%20shadows%2C%20muted%20cream%20and%20burgundy%20accents%2C%20elegant%20mysterious%20mood%2C%20no%20text&width=1200&height=760&seq=special-cover-04&orientation=landscape",
    intro:
      "伦理题材最容易滑向猎奇。这一辑挑选了七部在「看」与「被看」之间保持自觉的作品，它们不提供刺激，只提供视角。",
    reasons: [
      "入选标准是叙事立场：这些作品都在追问谁有资格讲述、谁被省略、谁在承担后果，而不是把禁忌当成卖点。",
      "从《纸月亮》的替身身份，到《静默的告白》里只敢对失智者说的话，七部作品从不同方向触碰同一条边界。",
      "阅读顺序建议由《余温》开始，它的日常感最强；最后再看《纸月亮》，你会更清楚「表演」在这类题材里意味着什么。",
    ],
    filmIds: ["paper-moon", "silent-confession", "afterglow", "red-thread", "glass-greenhouse", "midnight-clinic", "autumn-rite", "before-the-rain-stops"],
    curator: "编辑部 · 伦理题材研究",
    publishedAt: "2025-08-29",
    tags: ["改编", "叙事立场", "女性视角"],
  },
];